import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
// components
import AllowanceDetail from '../../../../components/modules/hr/allowance-detail';
import AllowanceDetailMiddleware from '../../../../middleware/modules/hr/allowance-detail';
import { Helmet } from 'react-helmet';
import i18n from '../../../../i18n';
// middlewares
 

const mapStateToProps = ({ auth,allowanceDetail }) => ({
  isProcessing: allowanceDetail.isProcessing,
  isError: allowanceDetail.isError,
  errorMessage: allowanceDetail.errorMessage,
  datalist:allowanceDetail.data,
  showModal:allowanceDetail.showModal
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    getHelper:()=>AllowanceDetailMiddleware.getHelper(),
    create: () =>AllowanceDetailMiddleware.create(),
    reset: () =>AllowanceDetailMiddleware.resetList(),
    search: data =>AllowanceDetailMiddleware.list(data),
    update: data =>AllowanceDetailMiddleware.update(data),
    delete: (id,search) =>AllowanceDetailMiddleware.beforeDelete(id,search),
  }, dispatch);
};
class AllowanceDetailContainer extends Component {
  
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    errorMessage: PropTypes.any,
    datalist: PropTypes.object,
    search: PropTypes.func.isRequired
  }

  static defaultProps = {
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isError: false,
    errorMessage: [],
  }

  constructor(props){
    super(props)
    this.deleteItem=this.deleteItem.bind(this);
    this.createItem=this.createItem.bind(this);
    this.updateItem=this.updateItem.bind(this);
  }

  componentWillMount() {
    const search = {
      limit: 10,
    };
    this.props.reset();
   this.props.search(search);
  
  }

  deleteItem(id,search){
    this.props.delete(id,search)
  }
  updateItem(id){
    this.props.getHelper()
    this.props.update(id)
  }
  createItem(){
    this.props.getHelper()
    this.props.create()
  }
  render() {
    const {datalist} = this.props;
    return (
      <React.Fragment>
        <Helmet>
          <title>
            {i18n.t("Allowance Detail List")}
          </title>
        </Helmet>
      <AllowanceDetail
        {...this.props}
        data={datalist}
        deleteItem={this.deleteItem}
        updateItem={this.updateItem}
        createData={this.createItem}
      />
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AllowanceDetailContainer);
